// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"db5793b1","667":"c957c4e0","977":"3eb4efac"}[chunkId] + ".chunk.js";
};